import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LOCALSTORAGEVARS } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  @Input() steps = [
    { title: 'paso 1', route: 'example', state: 'completed' },
    { title: 'paso 2', route: 'example', state: 'active' },
    { title: 'paso 3', route: 'example', state: 'normal' },
    { title: 'paso 2', route: 'example', state: 'error' }
  ];

  @Output() changeStep = new EventEmitter<string>();

  constructor(private router: Router) {}

  navigate(route: string) {
    this.router.navigate([route]);
  }

  validateRedirection(index: number) {
    if (JSON.parse(window.localStorage.getItem(LOCALSTORAGEVARS.redirectFromManual)) === true) {
      return index + 4;
    } else {
      return index + 1;
    }
  }
}
